import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';

const API_LIST = '/payees';
const API_DETAIL = (id: number) => `/payees/${id}`;

export interface Payee {
  id: number;
  name: string;
  notes?: string;
  email?: string;
  phone?: string;
  address?: string;
  vatNumber?: string;
  isActive: boolean;
  defaultCategoryId?: number;
  defaultSubcategoryId?: number;
  defaultCategory?: {
    id: number;
    name: string;
    p_crm_expense_subcategory?: { id: number; name: string }[];
  };
  defaultSubcategory?: { id: number; name: string };
}

export const usePayees = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<Payee[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    { revalidateOnFocus: true, revalidateOnReconnect: true }
  );
  return {
    data: data ?? [],
    isLoading,
    isError: !!error,
    mutate,
  };
};

export const usePayee = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Payee>(
    id ? API_DETAIL(id) : null,
    fetcher,
    { revalidateOnFocus: true }
  );
  return {
    data,
    isLoading,
    isError: !!error,
    mutate,
  };
};
